// extracted by mini-css-extract-plugin
export default {"container":"Space_container__sTYoI"};